import { Injectable, computed, inject, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { MicrosoftAuthService } from './authentication.service';
import { Global } from './Global';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class CertProService {
  private _http = inject(HttpClient)
  private _url = Global.url_certpro 
  private _token = inject(MicrosoftAuthService).token()
  private _headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', 'Bearer ' + this._token);

  getPeriod(period, entity) {
    return this._http.get(this._url + `entity/${period}${entity?.id ? "/" + entity.id : ""}`, { headers: this._headers })
  }
  getPeriods(year, group) {
    return this._http.get(this._url + `entities/${year}/${group.id}`, { headers: this._headers })
  }
  getCategories(type, year) {
    return this._http.get(this._url + `categories/${year}/${type.id}`, { headers: this._headers })
  }
  getQuestions(category) {
    return this._http.get(this._url + `questions/${category}`, { headers: this._headers })
  }
  updateCategory(category: any) {
    return this._http.patch(this._url + 'categories', category, { headers: this._headers })
  }

  updatePeriod(id: string, score?: Number, file?: string, expiration?: string) {
    return this._http.patch(this._url + 'update-period', {id, score, file, expiration}, { headers: this._headers })
  }

  updateQuestions(questions: any) {
    return this._http.patch(this._url + 'questions', questions, { headers: this._headers })
  }

  deleteQuestion(id: string) {
    return this._http.delete(this._url + 'questions/' + id, { headers: this._headers })
  }

  deleteSubQuestion(id: string) {
    return this._http.delete(this._url + 'subquestions/' + id, { headers: this._headers })
  }

  deleteCategory(id: string) {
    return this._http.delete(this._url + 'categories/' + id, { headers: this._headers })
  }
  
  getPreview(entity, year) {
    return this._http.get(this._url + `preview/${entity}/${year}`, { headers: this._headers })
  }

  getFile(file): Observable<Blob> {
    return this._http.get(this._url + 'file/' + file, { headers: this._headers, responseType: 'blob' })
  }

  uploadFile(answer, formData: FormData): Observable<any> {
    formData.append('answer', JSON.stringify(answer));
    return this._http.post(this._url + 'upload-file', formData)
  }

  uploadFilePeriod(period, formData: FormData): Observable<any> {
    formData.append('period', JSON.stringify(period));
    return this._http.post(this._url + 'upload-file/period', formData)
  }

  openPeriod(groupID: string, expirationDate: string, period: string) {
    return this._http.post(this._url + 'open-period', { group: groupID, expirationDate: expirationDate, period: period }, { headers: this._headers })
  }

  finishPeriod(data) {
    return this._http.patch(this._url + 'finish-period', data, { headers: this._headers })
  }

  signPeriod(certpro) {
    return this._http.patch(this._url + 'sign-period', certpro, { headers: this._headers })
  }

  auditPeriod(certpro) {
    return this._http.patch(this._url + 'audit-period', certpro, { headers: this._headers })
  }

  resetPeriod(periodId, expiration?) {
    return this._http.patch(this._url + 'reset-period', { id: periodId, expiration }, { headers: this._headers })
  }

  updateAnswer(item) {
    return this._http.patch(this._url + 'update-answer', item, { headers: this._headers })
  }
}
